export const OrderStatus = {
  CANCEL_DELETE: '취소삭제',
  MENTEE_CANCEL: '멘티취소',
  PARTIAL_CANCEL: '부분취소',
  CANCEL_NOT_ENOUGH_PROGRESS: '취소(진도율미달)',
  GROUP_PAYMENT_CANCEL: '그룹결제취소(멤버삭제)',
  PAYMENT_CANCEL: '결제취소',
  ORDER_FORM: '주문서작성',
  CONFLICT_CANCEL: '충돌취소',
  AUTO_CANCEL: '자동취소',
  PAYMENT_READY: '결제대기',
  TOTAL_CANCEL: '전체취소',
  PAYMENT_FAIL: '결제실패',
  PAYMENT_STOP: '결제중단',
  CODE_ORDER: '코드주문',
  ORDER_CANCEL: '주문취소',
  PAYMENT_COMPLETE: '결제완료',
  ADMIN_CANCEL: '관리자취소',
  MENTOR_CANCEL: '멘토취소',
  DEPOSIT_WAIT: '입금대기',
  WC_COMPLETED: 'wc-completed',
  MANUAL_DELETE: '수동삭제처리',
  PAYMENT_COMPLETE_PROCESSING: '결제완료처리중',
} as const;
